import React from 'react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Identify the Error',
    desc: "Follow the checklist to find where the County miscalculated your home's features."
  }, {
    num: '2',
    title: 'Gather the Proof',
    desc: "Use our 'Comps' method to find neighboring houses that pay less for the same value."
  }, {
    num: '3',
    title: 'Submit and Save',
    desc: 'Use the included letter template to formalize your appeal and watch your monthly payment drop.'
  }];
  return <section className="bg-white py-20 px-4 md:px-8" data-id="element-84">
      <div className="max-w-5xl mx-auto" data-id="element-85">
        <motion.div className="text-center mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-86">
          <h2 className="text-4xl md:text-5xl font-bold text-navy mb-6" data-id="element-87">
            How It Works
          </h2>
          <p className="text-xl text-gray-600" data-id="element-88">
            Three simple steps to reclaim your money.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-89">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gold/30 z-0" data-id="element-90"></div>

          {steps.map((step, i) => <motion.div key={i} className="relative z-10 flex flex-col items-center text-center" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2,
          duration: 0.6
        }} data-id="element-91">
              <div className="w-24 h-24 rounded-full bg-navy text-gold text-4xl font-bold flex items-center justify-center mb-8 shadow-xl border-4 border-white" data-id="element-92">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-charcoal mb-4" data-id="element-93">
                {step.title}
              </h3>
              <p className="text-lg text-gray-600 leading-relaxed" data-id="element-94">
                {step.desc}
              </p>
            </motion.div>)}
        </div>

        {/* Proof / Believability Callout */}
        <motion.div className="mt-20 bg-green/10 border border-green/30 rounded-2xl p-8 md:p-12 text-center max-w-4xl mx-auto" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-95">
          <h3 className="text-2xl md:text-3xl font-bold text-navy mb-6" data-id="element-96">
            What changes in 90 days:
          </h3>
          <p className="text-xl md:text-2xl text-charcoal leading-relaxed italic" data-id="element-97">
            "Imagine receiving a letter from your bank notifying you that your
            Escrow account has a surplus and your monthly payment is dropping by{' '}
            <strong className="text-green font-bold text-3xl mx-1" data-id="element-98">$150</strong>{' '}
            starting next month. This isn't magic; it's the result of correcting
            an inflated valuation that should have never existed."
          </p>
        </motion.div>
      </div>
    </section>;
}